"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _checkouts = require("@px/checkouts");
var _functions = require("./functions");
var _promoBanner = _interopRequireDefault(require("../../page-header/other/promo-banner"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
var _base = require("@site/pattern-library-utils/base.functions");
var _skeletonLoaderStyles = require("./skeleton-loader-styles");
var _loader = _interopRequireDefault(require("./loader.js"));
var _sharedModal = _interopRequireDefault(require("../../elements/other/shared-modal"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _layers = require("@site/pattern-library-utils/layers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

const BannerWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerWrapper",
  class: "pl-b1p9xjic"
});
const LoaderWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LoaderWrapper",
  class: "pl-l5b3efm"
});
const ErrorBannerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ErrorBannerContainer",
  class: "pl-esbm6pu"
});
function ErrorBanner({
  message
}) {
  return /*#__PURE__*/_react.default.createElement(ErrorBannerContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 0,
    text: message
  }));
}
ErrorBanner.propTypes = {
  message: _propTypes.default.string
};

/**
 * AddExpressCartButton Component
 *
 * @param {Object} props React props
 * @param {string} props.id The ID of the button
 * @param {string} props._name The name of the button
 * @param {string} props.text The text displayed on the button
 * @param {string} props.size The size of the button
 * @param {string} props.width The width of the button
 * @param {string} props.design The design of the button
 * @param {string} props.eid The event ID associated with the button
 * @param {boolean} props.disabled Whether the button is disabled
 * @param {string} props.ariaLabel The ARIA label for the button
 * @param {string} props.shrinkOn The condition to shrink the button
 * @param {string} props.partial The partial design of the button
 * @param {boolean} props.inverted Whether the button design is inverted
 * @param {function} props.handleClick The function to handle button click
 * @param {function} props.handleClose The function to handle modal close
 * @param {string} props.guid The GUID for the basket
 * @param {boolean} props.showExpressCart Whether to show the express cart.
 * @param {function} props.setShowExpressCart The function to set the visibility of the express cart
 * @param {function} props.setGuid The function to set the basket GUID
 * @param {string} props.productPackage The product package ID
 * @param {number} props.term The term length of the product package
 * @param {string} props.itc The item tracking code
 * @param {string} props.addToCartUrl The URL to add to cart
 * @param {string} props.appKey The app key for the checkout (defaults to 'fos-express')
 * @param {Object} props.expressCartBanner The banner for the express cart
 * @param {string} props.loadingMessage The loading message for the express cart
 * @param {Object} props.modalProps Additional props for the modal
 * @returns {React.ReactElement} AddExpressCartButton Component
 * @public
 */
function AddExpressCartButton({
  id,
  _name,
  text,
  size,
  width,
  design,
  ariaLabel,
  shrinkOn,
  partial,
  inverted,
  productPackage,
  term,
  itc,
  addToCartUrl,
  trackingCustomProperties,
  guid,
  setGuid,
  appKey = 'fos-express',
  expressCartBanner,
  loadingMessage,
  onError = () => null
}) {
  const [showExpressCart, setShowExpressCart] = (0, _react.useState)(false);
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const [isRequesting, setIsRequesting] = (0, _react.useState)(false);
  const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
  const [isHydrated, setIsHydrated] = (0, _react.useState)(false);
  const isInitialized = (0, _react.useRef)(false);
  const isAutoLaunchInProgress = (0, _react.useRef)(false);
  function saveGuidToLocalStorage(ctaId, newGuid) {
    localStorage.setItem(`basketId_${ctaId}`, newGuid);
  }
  function saveLastClickedButton(newGuid, ctaId) {
    localStorage.setItem(`autolaunch_basketId`, newGuid);
    localStorage.setItem(`autolaunch_ctaId`, ctaId);
  }
  function generateAndSetGuid() {
    const newGuid = (0, _functions.generateBasketGUID)();
    setGuid(newGuid);
    saveGuidToLocalStorage(id, newGuid);
  }
  function handleAutoLaunchModal(storedGuid) {
    if (isModalOpen || showExpressCart || isAutoLaunchInProgress.current) return;
    if (!storedGuid) {
      console.warn('No basketId found in local storage. Cannot auto-launch express cart.');
      return;
    }
    isAutoLaunchInProgress.current = true;
    setGuid(storedGuid);
    setIsModalOpen(true);
    setShowExpressCart(true);
  }
  (0, _react.useEffect)(() => {
    if (!isInitialized.current) {
      isInitialized.current = true;
      const cartRef = (0, _base.getQueryParamValue)('cart_ref');
      const isSSO = cartRef === 'sso';
      if (isSSO) {
        const autoLaunchGuid = localStorage.getItem('autolaunch_basketId');
        const autoLaunchCtaId = localStorage.getItem('autolaunch_ctaId');
        if (autoLaunchGuid && autoLaunchCtaId === id) {
          handleAutoLaunchModal(autoLaunchGuid);
          return;
        }
      } else {
        localStorage.removeItem('autolaunch_basketId');
        localStorage.removeItem('autolaunch_ctaId');
      }
      generateAndSetGuid();
    }
  }, [id]);
  (0, _react.useEffect)(() => {
    setIsHydrated(true);
  }, []);
  async function handleClick() {
    if (!isHydrated) return;
    try {
      setIsRequesting(true);
      await (0, _functions.addToExpressCart)({
        productPackage,
        term,
        itc,
        addToCartUrl,
        onError
      });
      saveLastClickedButton(guid, id);
      setIsModalOpen(true);
      setShowExpressCart(true);
    } catch (error) {
      console.error('Failed to add to cart:', error.message);
      if (!isModalOpen) {
        generateAndSetGuid();
      }
    } finally {
      setIsRequesting(false);
    }
  }
  function handleClose() {
    setIsModalOpen(false);
    setShowExpressCart(false);
    setErrorMessage(null);
    localStorage.removeItem('autolaunch_basketId');
    localStorage.removeItem('autolaunch_ctaId');
    isAutoLaunchInProgress.current = false;
    generateAndSetGuid();
  }
  function handleError(error) {
    setErrorMessage('We cannot process this transaction at this time. Please try again later.');
    switch (error.name) {
      case 'badPayloadError':
        handleClose();
        console.error('Bad Payload:', error.message);
        break;
      case 'authError':
        console.error('Authentication Error:', error.message);
        break;
      case 'accessError':
        console.error('Access Error:', error.message);
        break;
      default:
        console.error('Critical unexpected error:', error);
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    id: id,
    _name: _name,
    text: text,
    size: size,
    width: width,
    design: design,
    "data-cy": "add-to-express-cart-button",
    onClick: handleClick,
    type: "submit",
    "data-itc": itc,
    disabled: !isHydrated || isRequesting,
    "aria-label": ariaLabel,
    shrinkOn: shrinkOn,
    partial: partial || (inverted ? 'dark1' : ''),
    trackingCustomProperties: trackingCustomProperties
  }), isModalOpen && /*#__PURE__*/_react.default.createElement(_sharedModal.default, {
    id: "express-cart-modal",
    dataCy: "express-cart-modal",
    onClose: handleClose,
    show: isModalOpen,
    modalHash: "express-cart-modal"
  }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.ModalPatch, {
    maxKnownZIndex: _layers.knownZIndexes.overlay
  }), expressCartBanner && /*#__PURE__*/_react.default.createElement(BannerWrapper, null, /*#__PURE__*/_react.default.createElement(_promoBanner.default, (0, _extends2.default)({
    horizontalPadding: "none"
  }, expressCartBanner))), errorMessage && /*#__PURE__*/_react.default.createElement(BannerWrapper, null, /*#__PURE__*/_react.default.createElement(ErrorBanner, {
    message: errorMessage
  })), showExpressCart && !errorMessage && /*#__PURE__*/_react.default.createElement(_checkouts.Checkout, {
    id: "express-cart",
    appKey: appKey,
    basketId: guid,
    checkoutName: "ExpressCart",
    prefetchLaunch: true,
    preload: true,
    onError: handleError,
    onPurchaseSuccess: handleClose,
    loadingSpinner: /*#__PURE__*/_react.default.createElement(LoaderWrapper, null, /*#__PURE__*/_react.default.createElement(_loader.default, {
      loadingMessage: loadingMessage,
      SkeletonContainer: _skeletonLoaderStyles.SkeletonContainer,
      MessageContainer: _skeletonLoaderStyles.MessageContainer,
      Bars: _skeletonLoaderStyles.Bars,
      Container: _skeletonLoaderStyles.Container,
      Card: _skeletonLoaderStyles.Card,
      HeadRow: _skeletonLoaderStyles.HeadRow,
      Row: _skeletonLoaderStyles.Row,
      Button: _skeletonLoaderStyles.Button,
      SsoButtonWrapper: _skeletonLoaderStyles.SsoButtonWrapper,
      SsoButton: _skeletonLoaderStyles.SsoButton,
      Columns: _skeletonLoaderStyles.Columns
    }))
  })));
}
var _default = exports.default = AddExpressCartButton;
AddExpressCartButton.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  text: _propTypes.default.string,
  size: _propTypes.default.string,
  width: _propTypes.default.string,
  design: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  shrinkOn: _propTypes.default.string,
  partial: _propTypes.default.string,
  inverted: _propTypes.default.bool,
  guid: _propTypes.default.string,
  setGuid: _propTypes.default.func,
  productPackage: _propTypes.default.string,
  term: _propTypes.default.number,
  itc: _propTypes.default.string,
  addToCartUrl: _propTypes.default.string,
  appKey: _propTypes.default.string,
  expressCartBanner: _propTypes.default.shape(_promoBanner.default.propTypes),
  loadingMessage: _propTypes.default.string,
  onError: _propTypes.default.func,
  trackingCustomProperties: _propTypes.default.object
};